/* int-l4-carousel-fix.js: moved verbatim from snippets/carousel-fix.liquid (pdp-html-weight lever 4, 2026-11-02). Do not edit here without the source note. */
document.addEventListener('DOMContentLoaded', function () {
(function() {
  'use strict';

  var PATCHED = false;

  function patchPrototype() {
    if (PATCHED) return;
    var ctor = customElements.get('product-grid-item-image');
    if (!ctor) return;
    var orig = ctor.prototype.attributeChangedCallback;
    if (!orig) return;
    ctor.prototype.attributeChangedCallback = function(name, oldVal, newVal) {
      // Skip DOM replacement work for items inside recommendation carousels
      if (this.closest('.product-grid-slide')) return;
      return orig.call(this, name, oldVal, newVal);
    };
    PATCHED = true;
  }

  function eagerLoadCarousel(carousel) {
    
    return;
    // Force all images/variants to their eager/loaded state in one batch
    // Force all images/variants to their eager/loaded state in one batch
    // Use requestAnimationFrame to consolidate layout work
    requestAnimationFrame(function() {
      carousel.querySelectorAll('product-grid-item-image').forEach(function(el) {
        if (el.eagerLoad) el.eagerLoad();
      });
      carousel.querySelectorAll('product-grid-item-variant').forEach(function(el) {
        if (el.eagerLoad) el.eagerLoad();
      });
    });
  }

  function processCarousel(carousel) {
    // Only target recommendation carousels, never the main product slideshow
    if (!carousel.querySelector('.product-grid-slide')) return;
    // Defer eager-loading to avoid blocking initial render
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() { eagerLoadCarousel(carousel); }, { timeout: 2000 });
    } else {
      setTimeout(function() { eagerLoadCarousel(carousel); }, 200);
    }
  }

  function init() {
    // Patch the prototype once the custom element is registered
    patchPrototype();

    // Process any carousels already initialized
    document.querySelectorAll('.flickity-enabled').forEach(processCarousel);

    // Watch for carousels that initialize later (recommendations load async)
    var target = document.getElementById('shopify-section-template--27965836722440__related')
      || document.body;

    var observer = new MutationObserver(function(mutations) {
      // Re-attempt prototype patch if it hasn't happened yet
      if (!PATCHED) patchPrototype();

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        // Check if a flickity-enabled class was added
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var el = mutation.target;
          if (el.classList && el.classList.contains('flickity-enabled')) {
            processCarousel(el);
          }
        }
        // Check added nodes for flickity carousels
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('flickity-enabled')) {
              processCarousel(node);
            }
            // Also check descendants
            if (node.querySelectorAll) {
              node.querySelectorAll('.flickity-enabled').forEach(processCarousel);
            }
          }
        }
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // Safety cleanup: disconnect after 30s (carousels should be loaded by then)
    setTimeout(function() { observer.disconnect(); }, 30000);
  }

  // Run when DOM is ready, but don't block anything
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
});
